import React, { Dispatch, ReactElement, useEffect, useState } from 'react'
import tempLayer from "../assets/tempLayer.png";
import { useMapLayersContext } from '../provider/MapLayers';
import { LocationMarkerPopup } from "../mainLayer/MainWindow";

type LayerTemperaturePropsType = {
    name: string;
    color?: string;
}

const LayerTemperature = (props: LayerTemperaturePropsType) => {
    const { selectLayerInMap, loadLayerInMap,setIsTemperatureLoad } = useMapLayersContext();
    const [isSelectedTemperature, setIsSelectedTemperature] = useState<boolean>(false)
      
        useEffect(() => {
          if(loadLayerInMap === "temperature"){
            setIsSelectedTemperature(true);
            }else if(loadLayerInMap !== "temperature"){
                setIsSelectedTemperature(false);
            }
        }, [loadLayerInMap]);


        const TemperatureIconClick = () => {

        if (!isSelectedTemperature) {
            selectLayerInMap("temperature");
          } else {
            selectLayerInMap("temperaturenot");
          }
          setIsTemperatureLoad(false);
           };
        
        //   useEffect(() => {
        //     if (isSelectedTemperature) {
        //       selectLayerInMap("temperature");
        //     }else{
        //       LocationMarkerPopup("temperaturenot");
        //     }
        //   }, [isSelectedTemperature]);

    return (
        <div className={`subItemWrapper`}   onClick={(e) => TemperatureIconClick()} onTouchStart={(e) => TemperatureIconClick()}>
                {props.color && (
                    <div className={`colorBox ${isSelectedTemperature ? 'selected' : ''}`} style={{backgroundColor: `${props.color}`}}></div>
                )}

                <div className={`colorBox ${isSelectedTemperature ? 'selected' : ''}`}>
                    <img src={tempLayer} alt="" />
                </div>

                <span>{props.name}</span>
     
            </div>
    )
}

export default LayerTemperature;